import {
  FETCH_INIT,
  FETCHED,
  FETCHED_FAIL,
  SET_FILTER,
  SET_SORTING,
  CHANGE_PAGE,
  SET_SERVER_PAGE,
  RESET_LIST,
  UPDATE_ITEM,
} from "../actions/Feedback.action";
import Constants from "../config/constants";

function mapPresetFeedback(all, pageId) {
  return all.filter((val, index) => {
    if (
      index >=
        (pageId + 1) * Constants.DEFAULT_PAGE_VALUE -
          Constants.DEFAULT_PAGE_VALUE &&
      index < (pageId + 1) * Constants.DEFAULT_PAGE_VALUE
    ) {
      return val;
    }
    return null;
  });
}

const initialState = {
  all: [],
  present: [],
  currentPage: 0,
  serverPage: 0,
  query: null,
  query_data: null,
  sorting_data: { row: null, order: null },
  is_fetching: false,
  total: 0,
};

export default function (
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  switch (action.type) {
    case FETCH_INIT: {
      return { ...state, is_fetching: true };
    }
    case FETCHED: {
      const newData = action?.payload?.data || [];
      const page = action?.payload?.page || 1;
      const total = action?.payload?.total ?? state.total ?? 0;
      let newAll = [];
      if (page === 1) {
        newAll = [...newData];
      } else {
        newAll = [...state.all, ...newData];
      }
      const tableData = mapPresetFeedback(newAll, state.currentPage);
      return {
        ...state,
        all: newAll,
        present: tableData,
        is_fetching: false,
        total,
      };
    }
    case FETCHED_FAIL: {
      return { ...state, is_fetching: false };
    }
    case SET_SORTING: {
      return { ...state, sorting_data: action.payload };
    }
    case SET_FILTER: {
      return {
        ...state,
        query: action.payload?.query,
        query_data: action.payload?.query_data,
      };
    }
    case CHANGE_PAGE: {
      const tempPage = action.payload;
      const tableData = mapPresetFeedback(state.all, tempPage);
      return { ...state, present: tableData, currentPage: tempPage };
    }
    case SET_SERVER_PAGE: {
      return { ...state, serverPage: action.payload };
    }
    case RESET_LIST: {
      return { ...JSON.parse(JSON.stringify(initialState)) };
    }
    case UPDATE_ITEM: {
      if (!action.payload) {
        return state;
      }
      const updatedItem = action.payload;
      const prevState = [...state.all];
      const index = prevState.findIndex((val) => val.id === updatedItem.id);
      if (index >= 0) {
        prevState[index] = { ...prevState[index], ...updatedItem };
        const tableData = mapPresetFeedback(prevState, state.currentPage);
        return { ...state, all: prevState, present: tableData };
      }
      return state;
    }
    default: {
      return state;
    }
  }
}

